import { render, staticRenderFns } from "./fccTratamentoColegiosTabela.vue?vue&type=template&id=9c5673ee"
import script from "./fccTratamentoColegiosTabela.vue?vue&type=script&lang=js"
export * from "./fccTratamentoColegiosTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports